module.exports = __webpack_public_path__ + "static/media/rubrik.85173e9d.jpg";